<template>
  <div class="createOrder-page full-height">
    <full-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders/orderList' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>消息提醒</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="full" class="message full-height display-col">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="$t('mess.mess1')" name="first" :key="'first'">
            <child1 v-if="isChildUpdate1"></child1>
          </el-tab-pane>
          <el-tab-pane :label="$t('mess.mess2')" name="second" :key="'second'">
            <child2 v-if="isChildUpdate2"></child2>
          </el-tab-pane>
        </el-tabs>
      </div>
    </full-con>
  </div>
</template>
<script>
import inBox from './inBox'
import outBox from './outBox'
export default {
  name: 'message',
  components: {
    child1: inBox,
    child2: outBox
  },
  data () {
    return {
      activeName: 'first',
      // 初始化两个变量 isChildUpdate1:true，isChildUpdate2:false；
      // 使用v-if控制child1和child2是否渲染。
      // 每次切换tab选项的时候，触发事件。让当前点击的tab变量设置位true，让当前组件重新渲染。
      // 这时候当你来回切换的时候，通过v-if判断是否重新渲染当前组件
      isChildUpdate1: true,
      isChildUpdate2: false
    }
  },
  mounted () {
  },
  methods: {
    handleClick (tab) {
      if (tab.name === 'first') {
        this.isChildUpdate1 = true
        this.isChildUpdate2 = false
      } else if (tab.name === 'second') {
        this.isChildUpdate1 = false
        this.isChildUpdate2 = true
      }
    }
  }
}
</script>
<style lang="less" scoped>
.el-tab-pane {
  height: 700px;
}
</style>